<template>
  <div class="w-full">
    <div>
      <SmartTitle
        class="form-list__title mb-2 mt-1 mr-2"
        style="margin-left: 5px!important"
        weight="medium"
        heading="1"
      >
        LOG - Gestão de Venda
      </SmartTitle>
    </div>
    <div>
      <FilterSaleLogs
        ref="filterSaleLogs"
        @searchWithFilter="search"
        @clearFilter="clear"
        v-bind:enable="enableBtnSearch"
      />
    </div>
    <div class="flex justify-between align-center mb-4">
      <form class="left flex" @submit.prevent="search">
        <VSelect
          :items="userTypes"
          v-model="selectedUserType"
          label="Tipo de Usuário"
          placeholder="Escolha um tipo"
          name="usersType"
          class="sm:col-12 lg:col-6 mb-1"
        >
          <template v-slot:item="{ item, index }">
            <div class="v-list__tile__content">
              <div :id="`user-type-${index}`" class="v-list__tile__title">{{ item.text }}</div>
            </div>
          </template>
        </VSelect>
        <SmartInput
          class="lg:col-6 cursor-pointer"
          label="Nome/Matrícula do Usuário"
          placeholder="Buscar por matrícula ou nome"
          v-model="selectedRegistration"
          :disabled="!enableSearch"
          title="Selecione primeiro o Tipo de usuário"
        />
      </form>
      <div class="right inline-flex mt-3">
        <SmartButton
          @click="download"
          class="mr-2 inline-flex"
          :disabled="enableBtnSearch"
          title="Selecione também o nome ou matrícula do usuário"
        >
          <SmartIcon name="upload" :size="2" />
          Exportar Arquivo
        </SmartButton>
      </div>
    </div>
    <vue-scroll :ops="ops" v-if="!loading">
      <VDataTable
        class="align-start table-div flex-1"
        id="logs-table"
        :headers="headers"
        :items="logSales"
        hide-actions
        :class="{ loading: false }"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.modifierUserName }}</td>
          <td>{{ props.item.modifierUserRegistration }}</td>
          <td>{{ props.item.createdAt }}</td>
          <td>{{ props.item.saleUserName }}</td>
          <td>{{ props.item.saleUserRegistration }}</td>
          <td>{{ props.item.modifiedColumn }}</td>
          <td>{{ props.item.oldValue }}</td>
          <td>{{ props.item.updatedValue }}</td>
          <td class="view-icon">
            <label
              @click="showLogInfo(props.item.id)"
              class="flex flex-row align-center justify-center cursor-pointer"
            >
              <SmartIcon :size="2" name="view" class="mr-1-2" />
            </label>
          </td>
        </template>
      </VDataTable>
    </vue-scroll>
    <SmartCard class="mt-1 p-3" v-else>
      <SmartSkeletonLoading :items="11" :height="4" />
    </SmartCard>
    <div class="flex justify-center mt-4">
      <v-pagination
        v-if="currentPage"
        v-model="pagination.page"
        @input="changePage"
        :length="length"
        :value="currentPage"
        :total-visible="7"
        circle
      />
    </div>
    <div>
      <SmartDrawer @close="closeDrawer" :show="showLogDrawer">
        <template v-slot:header>
          <SmartTitle class="text-brand-secondary" weight="regular">
            Detalhes
          </SmartTitle>
        </template>
        <InfoSaleLogs :saleLogs="saleLogs" @cancel="closeDrawer" />
      </SmartDrawer>
      <SmartModal v-if="modal" v-bind="modal" @close="modal = null">
        {{ modal.text }}
      </SmartModal>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { downloadXlsFile, getBlobError } from 'utils/blob';
import { serialize } from 'utils';
import vuescroll from 'vuescroll';
import { formatBRDate, formatBRDateTime, formatUSDate, validateDate } from 'utils/date';

export default {
  components: {
    FilterSaleLogs: () => import('./FilterSaleLogs.vue'),
    InfoSaleLogs: () => import('./InfoSaleLogs.vue')
  },
  data() {
    return {
      ops: {
        bar: {
          background: '#000',
          opacity: 0.2,
          keepShow: true
        }
      },
      modal: null,
      enabledBtnSearch: false,
      size: 10,
      saleLogs: {},
      loading: false,
      showLogDrawer: false,
      selectedRegistration: null,
      selectedUserType: null,
      userTypes: [{ value: 'supervisor', text: 'Supervisor' }, { value: 'user', text: 'Vendedor' }],
      pagination: {
        rowsPerPage: 10,
        page: 1
      },
      headers: [
        { text: 'Nome', value: 'modifier_user_name' },
        { text: 'Matrícula', value: 'modifier_user_registration' },
        { text: 'Data/Hora', value: 'created_at' },
        { text: 'Vendedor', value: 'sale_user_name' },
        { text: 'Matrícula Vendedor', value: 'sale_user_registration' },
        { text: 'Coluna Modificada', value: 'modified_column' },
        { text: 'Informações Antigas', value: 'old_value' },
        { text: 'Informações Atuais', value: 'updated_value' },
        { text: 'Detalhes', value: 'actions' }
      ]
    };
  },
  filters: {
    tell(value) {
      return value && value.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3');
    }
  },
  computed: {
    ...mapGetters({
      saleLogsManagement: 'saleLog/saleLogsManagement',
      saleLogsPagination: 'saleLog/pagination'
    }),
    enableSearch() {
      return this.selectedUserType ? true : false;
    },
    enableBtnSearch() {
      if (this.selectedUserType == null || this.selectedUserType == '') {
        this.enabledBtnSearch = false;
      } else if (this.selectedRegistration == null || this.selectedRegistration == '') {
        this.enabledBtnSearch = true;
      } else {
        this.enabledBtnSearch = false;
      }

      return this.enabledBtnSearch;
    },
    length() {
      return this.saleLogsPagination && this.saleLogsPagination.last_page;
    },
    currentPage() {
      return this.saleLogsPagination && this.saleLogsPagination.current_page;
    },
    logSales() {
      return (
        (this.saleLogsManagement &&
          this.saleLogsManagement.map(saleLogs => ({
            id: saleLogs.id,
            saleId: saleLogs.sale_id,
            saleType: saleLogs.sale_type,
            modifierUserName: saleLogs.modifier_user_name ? saleLogs.modifier_user_name : '-',
            modifierUserRegistration: saleLogs.modifier_user_registration
              ? saleLogs.modifier_user_registration
              : '-',
            saleUserName: saleLogs.sale_user_name ? saleLogs.sale_user_name : '-',
            saleUserRegistration: saleLogs.sale_user_registration
              ? saleLogs.sale_user_registration
              : '-',
            viewGerencial: saleLogs.view_gerencial ? saleLogs.view_gerencial : '-',
            modifiedColumn:
              saleLogs.modified_column == 'c6bank'
                ? 'C6 Bank'
                : saleLogs.modified_column == 'sale_date'
                ? 'Data da Venda'
                : saleLogs.modified_column == 'category'
                ? 'Tipo de Ativação'
                : saleLogs.modified_column == 'msisdn'
                ? 'Telefone'
                : saleLogs.modified_column == 'deleted_at'
                ? 'Excluído'
                : saleLogs.modified_column == 'value'
                ? 'Valor da Venda'
                : saleLogs.modified_column == 'gadget_id'
                ? 'Modelo'
                : saleLogs.modified_column == 'offer_id'
                ? 'Oferta'
                : saleLogs.modified_column == 'serial_number'
                ? 'Número de Série'
                : saleLogs.modified_column == 'customer_cpf'
                ? 'CPF'
                : saleLogs.modified_column,
            oldValue:
              saleLogs.modified_column == 'deleted_at'
                ? '-'
                : saleLogs.modified_column == 'value'
                ? 'R$ ' + saleLogs.old_value
                : saleLogs.modified_column == 'gadget_id'
                ? saleLogs.old_value
                : saleLogs.modified_column == 'serial_number'
                ? saleLogs.old_value
                : saleLogs.modified_column == 'offer_id'
                ? saleLogs.old_value
                : saleLogs.modified_column == 'msisdn'
                ? this.$options.filters.tell(saleLogs.old_value)
                : saleLogs.old_value == 1
                ? 'Sim'
                : saleLogs.old_value == 0
                ? 'Não'
                : validateDate(saleLogs.old_value)
                ? formatBRDateTime(saleLogs.old_value)
                : saleLogs.old_value == null
                ? '-'
                : saleLogs.old_value,
            updatedValue:
              saleLogs.modified_column == 'deleted_at'
                ? '-'
                : saleLogs.modified_column == 'value'
                ? 'R$ ' + saleLogs.updated_value
                : saleLogs.modified_column == 'gadget_id'
                ? saleLogs.updated_value
                : saleLogs.modified_column == 'serial_number'
                ? saleLogs.updated_value
                : saleLogs.modified_column == 'offer_id'
                ? saleLogs.updated_value
                : saleLogs.modified_column == 'msisdn'
                ? this.$options.filters.tell(saleLogs.updated_value)
                : saleLogs.updated_value == 1
                ? 'Sim'
                : saleLogs.updated_value == 0
                ? 'Não'
                : validateDate(saleLogs.updated_value)
                ? formatBRDateTime(saleLogs.updated_value)
                : saleLogs.updated_value == null
                ? '-'
                : saleLogs.updated_value,
            createdAt: saleLogs.created_at ? formatBRDateTime(saleLogs.created_at) : '-',
            updatedAt: saleLogs.updated_at ? formatBRDateTime(saleLogs.updated_at) : '-'
          }))) ||
        []
      );
    }
  },
  methods: {
    ...mapActions({
      fetchSaleLogsManagement: 'saleLog/fetchSaleLogsManagement',
      downloadSaleLog: 'saleManagement/downloadSaleLog'
    }),
    async download() {
      if (this.selectedUserType) {
        let filterUserType = {};
        let registration = {};
        var finalFilter = '';

        filterUserType = { ...filterUserType, selectedUserType: this.selectedUserType };
        const filterUserTypeSerealized = serialize(filterUserType);

        registration = { ...registration, selectedRegistration: this.selectedRegistration };
        const registrationSerealized = serialize(registration);

        if (this.$refs.filterSaleLogs.filters) {
          finalFilter =
            this.$refs.filterSaleLogs.filters +
            '&' +
            filterUserTypeSerealized +
            '&' +
            registrationSerealized;
        } else {
          finalFilter = filterUserTypeSerealized + '&' + registrationSerealized;
        }
      } else {
        finalFilter = this.$refs.filterSaleLogs.filters;
      }
      this.downloadSaleLog(finalFilter)
        .then(data => {
          const currentDate = new Date().toISOString();
          downloadXlsFile({ filename: currentDate, file: data });
        })
        .catch(error => {
          getBlobError(error).then(result => {
            this.modal = {
              type: 'warning',
              title: 'Ops!',
              icon: 'alert',
              buttonText: 'Cancelar',
              text: JSON.parse(result).message
            };
          });
        });
    },
    showLogInfo(id) {
      const tempSaleLogs = this.saleLogsManagement.find(saleLogs => saleLogs.id === id);
      this.saleLogs = {
        id: tempSaleLogs.id,
        saleId: tempSaleLogs.sale_id,
        saleType: tempSaleLogs.sale_type,
        modifierUserName: tempSaleLogs.modifier_user_name,
        modifierUserRegistration: tempSaleLogs.modifier_user_registration,
        saleUserName: tempSaleLogs.sale_user_name,
        saleUserRegistration: tempSaleLogs.sale_user_registration,
        viewGerencial: tempSaleLogs.view_gerencial,
        modifiedColumn:
          tempSaleLogs.modified_column == 'c6bank'
            ? 'C6 Bank'
            : tempSaleLogs.modified_column == 'sale_date'
            ? 'Data da Venda'
            : tempSaleLogs.modified_column == 'category'
            ? 'Tipo de Ativação'
            : tempSaleLogs.modified_column == 'msisdn'
            ? 'Telefone'
            : tempSaleLogs.modified_column == 'deleted_at'
            ? 'Excluído'
            : tempSaleLogs.modified_column == 'value'
            ? 'Valor da Venda'
            : tempSaleLogs.modified_column == 'gadget_id'
            ? 'Modelo'
            : tempSaleLogs.modified_column == 'offer_id'
            ? 'Oferta'
            : tempSaleLogs.modified_column == 'serial_number'
            ? 'Número de Série'
            : tempSaleLogs.modified_column == 'customer_cpf'
            ? 'CPF'
            : tempSaleLogs.modified_column,
        oldValue:
          tempSaleLogs.modified_column == 'deleted_at'
            ? '-'
            : tempSaleLogs.modified_column == 'value'
            ? 'R$ ' + tempSaleLogs.old_value
            : tempSaleLogs.modified_column == 'gadget_id'
            ? tempSaleLogs.old_value
            : tempSaleLogs.modified_column == 'serial_number'
            ? tempSaleLogs.old_value
            : tempSaleLogs.modified_column == 'offer_id'
            ? tempSaleLogs.old_value
            : tempSaleLogs.modified_column == 'msisdn'
            ? this.$options.filters.tell(tempSaleLogs.old_value)
            : tempSaleLogs.old_value == 1
            ? 'Sim'
            : tempSaleLogs.old_value == 0
            ? 'Não'
            : validateDate(tempSaleLogs.old_value)
            ? formatBRDateTime(tempSaleLogs.old_value)
            : tempSaleLogs.old_value == null
            ? '-'
            : tempSaleLogs.old_value,
        updatedValue:
          tempSaleLogs.modified_column == 'deleted_at'
            ? '-'
            : tempSaleLogs.modified_column == 'value'
            ? 'R$ ' + tempSaleLogs.updated_value
            : tempSaleLogs.modified_column == 'gadget_id'
            ? tempSaleLogs.updated_value
            : tempSaleLogs.modified_column == 'serial_number'
            ? tempSaleLogs.updated_value
            : tempSaleLogs.modified_column == 'offer_id'
            ? tempSaleLogs.updated_value
            : tempSaleLogs.modified_column == 'msisdn'
            ? this.$options.filters.tell(tempSaleLogs.updated_value)
            : tempSaleLogs.updated_value == 1
            ? 'Sim'
            : tempSaleLogs.updated_value == 0
            ? 'Não'
            : validateDate(tempSaleLogs.updated_value)
            ? formatBRDateTime(tempSaleLogs.updated_value)
            : tempSaleLogs.updated_value == null
            ? '-'
            : tempSaleLogs.updated_value,
        createdAt: formatBRDateTime(tempSaleLogs.created_at),
        updatedAt: formatBRDateTime(tempSaleLogs.updated_at)
      };
      this.showLogDrawer = true;
    },
    changePage(page) {
      let filterSaleLogsFilters = this.$refs.filterSaleLogs && this.$refs.filterSaleLogs.filters;

      if (this.selectedUserType) {
        const serializedRegistration = `${this.selectedUserType}=${this.selectedRegistration}`;

        filterSaleLogsFilters += filterSaleLogsFilters
          ? `&${serializedRegistration}`
          : serializedRegistration;
      }

      this.loading = true;
      this.fetchSaleLogsManagement({
        page,
        filters: filterSaleLogsFilters
      }).then(() => {
        this.loading = false;
      });
    },
    closeDrawer() {
      this.showLogDrawer = false;
    },
    search() {
      this.changePage(this.currentPage);
    },
    clear() {
      this.selectedUserType = '';
      this.selectedRegistration = '';
    }
  },
  async mounted() {
    await this.changePage(1);
  }
};
</script>

<style scoped lang="css">
#logs-table td {
  text-overflow: ellipsis;
  max-width: 200px;
  overflow: hidden;
  white-space: nowrap;
  transition: 1s
}
#logs-table td:hover {
  max-width: 1000px!important;
  transition: 1s
}
</style>
